// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_Result = require("rescript/lib/js/belt_Result.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Caml_js_exceptions = require("rescript/lib/js/caml_js_exceptions.js");
var Expln_utils_common = require("./Expln_utils_common.bs.js");

function pathToStr(path) {
  if (path) {
    return Belt_List.reduceReverse(path, "", (function (a, e) {
                  return a + "/" + e;
                }));
  } else {
    return "/";
  }
}

function jsonToAny(json, path) {
  var num = Js_json.classify(json);
  if (typeof num === "number") {
    switch (num) {
      case /* JSONFalse */0 :
          return {
                  TAG: /* JsonBool */1,
                  _0: false,
                  _1: path
                };
      case /* JSONTrue */1 :
          return {
                  TAG: /* JsonBool */1,
                  _0: true,
                  _1: path
                };
      case /* JSONNull */2 :
          return {
                  TAG: /* JsonNull */0,
                  _0: path
                };
      
    }
  } else {
    switch (num.TAG | 0) {
      case /* JSONString */0 :
          return {
                  TAG: /* JsonStr */3,
                  _0: num._0,
                  _1: path
                };
      case /* JSONNumber */1 :
          return {
                  TAG: /* JsonNum */2,
                  _0: num._0,
                  _1: path
                };
      case /* JSONObject */2 :
          return {
                  TAG: /* JsonObj */5,
                  _0: num._0,
                  _1: path
                };
      case /* JSONArray */3 :
          return {
                  TAG: /* JsonArr */4,
                  _0: num._0,
                  _1: path
                };
      
    }
  }
}

function getPath(jsonAny) {
  if (jsonAny.TAG === /* JsonNull */0) {
    return jsonAny._0;
  } else {
    return jsonAny._1;
  }
}

function anyToBool(jsonAny) {
  switch (jsonAny.TAG | 0) {
    case /* JsonNull */0 :
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
    case /* JsonBool */1 :
        return {
                TAG: /* Ok */0,
                _0: jsonAny._0
              };
    default:
      return {
              TAG: /* Error */1,
              _0: "a boolean value was expected at '" + pathToStr(getPath(jsonAny)) + "'."
            };
  }
}

function anyToNum(jsonAny) {
  switch (jsonAny.TAG | 0) {
    case /* JsonNull */0 :
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
    case /* JsonNum */2 :
        return {
                TAG: /* Ok */0,
                _0: jsonAny._0
              };
    default:
      return {
              TAG: /* Error */1,
              _0: "a number value was expected at '" + pathToStr(getPath(jsonAny)) + "'."
            };
  }
}

function anyToInt(jsonAny) {
  return Belt_Result.map(anyToNum(jsonAny), (function (numOpt) {
                return Belt_Option.map(numOpt, (function (num) {
                              return num | 0;
                            }));
              }));
}

function anyToStr(jsonAny) {
  switch (jsonAny.TAG | 0) {
    case /* JsonNull */0 :
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
    case /* JsonStr */3 :
        return {
                TAG: /* Ok */0,
                _0: jsonAny._0
              };
    default:
      return {
              TAG: /* Error */1,
              _0: "a string value was expected at '" + pathToStr(getPath(jsonAny)) + "'."
            };
  }
}

function anyToArr(jsonAny, mapper) {
  switch (jsonAny.TAG | 0) {
    case /* JsonNull */0 :
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
    case /* JsonArr */4 :
        var path = jsonAny._1;
        return {
                TAG: /* Ok */0,
                _0: jsonAny._0.map(function (json, i) {
                      return Curry._1(mapper, jsonToAny(json, {
                                      hd: String(i),
                                      tl: path
                                    }));
                    })
              };
    default:
      return {
              TAG: /* Error */1,
              _0: "an array was expected at '" + pathToStr(getPath(jsonAny)) + "'."
            };
  }
}

function anyToObj(jsonAny, mapper) {
  switch (jsonAny.TAG | 0) {
    case /* JsonNull */0 :
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
    case /* JsonObj */5 :
        return {
                TAG: /* Ok */0,
                _0: Caml_option.some(Curry._1(mapper, jsonAny))
              };
    default:
      return {
              TAG: /* Error */1,
              _0: "an object was expected at '" + pathToStr(getPath(jsonAny)) + "'."
            };
  }
}

function getByPath(obj, attrName) {
  if (obj.TAG !== /* JsonObj */5) {
    return {
            TAG: /* Error */1,
            _0: "an object was expected at '" + pathToStr(getPath(obj)) + "'."
          };
  }
  var json = Js_dict.get(obj._0, attrName);
  if (json !== undefined) {
    return {
            TAG: /* Ok */0,
            _0: jsonToAny(Caml_option.valFromOption(json), {
                  hd: attrName,
                  tl: obj._1
                })
          };
  } else {
    return {
            TAG: /* Ok */0,
            _0: undefined
          };
  }
}

function validate(val, validator) {
  if (validator === undefined) {
    return val;
  }
  var val$1 = Curry._1(validator, val);
  if (val$1.TAG === /* Ok */0) {
    return val$1._0;
  } else {
    return Expln_utils_common.exn(val$1._0);
  }
}

function getDefaultOrExn($$default, errMsg) {
  if ($$default !== undefined) {
    return Curry._1($$default, undefined);
  } else {
    return Expln_utils_common.exn(Curry._1(errMsg, undefined));
  }
}

function makeAsValOpt(anyToVal, jsonAny, validator, $$default, param) {
  var valOpt = Curry._1(anyToVal, jsonAny);
  if (valOpt.TAG === /* Ok */0) {
    return validate(valOpt._0, validator);
  }
  var msg = valOpt._0;
  return getDefaultOrExn($$default, (function (param) {
                return msg;
              }));
}

function makeAsVal(anyToVal, descrOfExpectedValue, jsonAny, validator, $$default, param) {
  var msg = Curry._1(anyToVal, jsonAny);
  if (msg.TAG === /* Ok */0) {
    var val = msg._0;
    if (val !== undefined) {
      return validate(Caml_option.valFromOption(val), validator);
    } else {
      return getDefaultOrExn($$default, (function (param) {
                    return "" + descrOfExpectedValue + " was expected at '" + pathToStr(getPath(jsonAny)) + "'.";
                  }));
    }
  }
  var msg$1 = msg._0;
  return getDefaultOrExn($$default, (function (param) {
                return msg$1;
              }));
}

function makeValOpt(asValOpt, jsonAny, attrName, validator, $$default, param) {
  var match = getByPath(jsonAny, attrName);
  if (match.TAG !== /* Ok */0) {
    return getDefaultOrExn($$default, (function (param) {
                  return "an object was expected at '" + pathToStr(getPath(jsonAny)) + "'.";
                }));
  }
  var attrVal = match._0;
  if (attrVal !== undefined) {
    return Curry._4(asValOpt, attrVal, validator, $$default, undefined);
  } else {
    return validate(undefined, validator);
  }
}

function makeVal(asVal, descrOfExpectedValue, jsonAny, attrName, validator, $$default, param) {
  var match = getByPath(jsonAny, attrName);
  if (match.TAG !== /* Ok */0) {
    return getDefaultOrExn($$default, (function (param) {
                  return "an object was expected at '" + pathToStr(getPath(jsonAny)) + "'.";
                }));
  }
  var attrVal = match._0;
  if (attrVal !== undefined) {
    return Curry._4(asVal, attrVal, validator, $$default, undefined);
  } else {
    return getDefaultOrExn($$default, (function (param) {
                  var path = getPath(jsonAny);
                  return "" + descrOfExpectedValue + " was expected at '" + pathToStr({
                              hd: attrName,
                              tl: path
                            }) + "'.";
                }));
  }
}

function asBoolOpt(param, param$1, param$2, param$3) {
  return makeAsValOpt(anyToBool, param, param$1, param$2, param$3);
}

function asBool(param, param$1, param$2, param$3) {
  return makeAsVal(anyToBool, "a boolean", param, param$1, param$2, param$3);
}

function boolOpt(param, param$1, param$2, param$3, param$4) {
  return makeValOpt(asBoolOpt, param, param$1, param$2, param$3, param$4);
}

function bool(param, param$1, param$2, param$3, param$4) {
  return makeVal(asBool, "a boolean", param, param$1, param$2, param$3, param$4);
}

function asNumOpt(param, param$1, param$2, param$3) {
  return makeAsValOpt(anyToNum, param, param$1, param$2, param$3);
}

function asNum(param, param$1, param$2, param$3) {
  return makeAsVal(anyToNum, "a number", param, param$1, param$2, param$3);
}

function numOpt(param, param$1, param$2, param$3, param$4) {
  return makeValOpt(asNumOpt, param, param$1, param$2, param$3, param$4);
}

function num(param, param$1, param$2, param$3, param$4) {
  return makeVal(asNum, "a number", param, param$1, param$2, param$3, param$4);
}

function asIntOpt(param, param$1, param$2, param$3) {
  return makeAsValOpt(anyToInt, param, param$1, param$2, param$3);
}

function asInt(param, param$1, param$2, param$3) {
  return makeAsVal(anyToInt, "an integer", param, param$1, param$2, param$3);
}

function intOpt(param, param$1, param$2, param$3, param$4) {
  return makeValOpt(asIntOpt, param, param$1, param$2, param$3, param$4);
}

function $$int(param, param$1, param$2, param$3, param$4) {
  return makeVal(asInt, "an integer", param, param$1, param$2, param$3, param$4);
}

function asStrOpt(param, param$1, param$2, param$3) {
  return makeAsValOpt(anyToStr, param, param$1, param$2, param$3);
}

function asStr(param, param$1, param$2, param$3) {
  return makeAsVal(anyToStr, "a string", param, param$1, param$2, param$3);
}

function strOpt(param, param$1, param$2, param$3, param$4) {
  return makeValOpt(asStrOpt, param, param$1, param$2, param$3, param$4);
}

function str(param, param$1, param$2, param$3, param$4) {
  return makeVal(asStr, "a string", param, param$1, param$2, param$3, param$4);
}

function asArrOpt(arr, mapper, validator, $$default, param) {
  var arrOpt = anyToArr(arr, mapper);
  if (arrOpt.TAG === /* Ok */0) {
    return validate(arrOpt._0, validator);
  }
  var msg = arrOpt._0;
  return getDefaultOrExn($$default, (function (param) {
                return msg;
              }));
}

function asArr(arr, mapper, validator, $$default, param) {
  var msg = anyToArr(arr, mapper);
  if (msg.TAG === /* Ok */0) {
    var arrVal = msg._0;
    if (arrVal !== undefined) {
      return validate(arrVal, validator);
    } else {
      return getDefaultOrExn($$default, (function (param) {
                    return "an array was expected at '" + pathToStr(getPath(arr)) + "'.";
                  }));
    }
  }
  var msg$1 = msg._0;
  return getDefaultOrExn($$default, (function (param) {
                return msg$1;
              }));
}

function arrOpt(obj, attrName, mapper, validator, $$default, param) {
  var match = getByPath(obj, attrName);
  if (match.TAG !== /* Ok */0) {
    return getDefaultOrExn($$default, (function (param) {
                  return "an object was expected at '" + pathToStr(getPath(obj)) + "'.";
                }));
  }
  var attrVal = match._0;
  if (attrVal !== undefined) {
    return asArrOpt(attrVal, mapper, validator, $$default, undefined);
  } else {
    return validate(undefined, validator);
  }
}

function arr(obj, attrName, mapper, validator, $$default, param) {
  var match = getByPath(obj, attrName);
  if (match.TAG !== /* Ok */0) {
    return getDefaultOrExn($$default, (function (param) {
                  return "an object was expected at '" + pathToStr(getPath(obj)) + "'.";
                }));
  }
  var attrVal = match._0;
  if (attrVal !== undefined) {
    return asArr(attrVal, mapper, validator, $$default, undefined);
  } else {
    return getDefaultOrExn($$default, (function (param) {
                  var path = getPath(obj);
                  return "an array was expected at '" + pathToStr({
                              hd: attrName,
                              tl: path
                            }) + "'.";
                }));
  }
}

function asObjOpt(obj, mapper, validator, $$default, param) {
  var objOpt = anyToObj(obj, mapper);
  if (objOpt.TAG === /* Ok */0) {
    return validate(objOpt._0, validator);
  }
  var msg = objOpt._0;
  return getDefaultOrExn($$default, (function (param) {
                return msg;
              }));
}

function asObj(arr, mapper, validator, $$default, param) {
  var msg = anyToObj(arr, mapper);
  if (msg.TAG === /* Ok */0) {
    var objVal = msg._0;
    if (objVal !== undefined) {
      return validate(Caml_option.valFromOption(objVal), validator);
    } else {
      return getDefaultOrExn($$default, (function (param) {
                    return "an object was expected at '" + pathToStr(getPath(arr)) + "'.";
                  }));
    }
  }
  var msg$1 = msg._0;
  return getDefaultOrExn($$default, (function (param) {
                return msg$1;
              }));
}

function objOpt(obj, attrName, mapper, validator, $$default, param) {
  var match = getByPath(obj, attrName);
  if (match.TAG !== /* Ok */0) {
    return getDefaultOrExn($$default, (function (param) {
                  return "an object was expected at '" + pathToStr(getPath(obj)) + "'.";
                }));
  }
  var attrVal = match._0;
  if (attrVal !== undefined) {
    return asObjOpt(attrVal, mapper, validator, $$default, undefined);
  } else {
    return validate(undefined, validator);
  }
}

function obj(obj$1, attrName, mapper, validator, $$default, param) {
  var match = getByPath(obj$1, attrName);
  if (match.TAG !== /* Ok */0) {
    return getDefaultOrExn($$default, (function (param) {
                  return "an object was expected at '" + pathToStr(getPath(obj$1)) + "'.";
                }));
  }
  var attrVal = match._0;
  if (attrVal !== undefined) {
    return asObj(attrVal, mapper, validator, $$default, undefined);
  } else {
    return getDefaultOrExn($$default, (function (param) {
                  var path = getPath(obj$1);
                  return "an object was expected at '" + pathToStr({
                              hd: attrName,
                              tl: path
                            }) + "'.";
                }));
  }
}

function fromJson(json, mapper, validator, $$default, param) {
  try {
    var jsonAny = jsonToAny(json, /* [] */0);
    return {
            TAG: /* Ok */0,
            _0: validate(Curry._1(mapper, jsonAny), validator)
          };
  }
  catch (raw_ex){
    var ex = Caml_js_exceptions.internalToOCamlException(raw_ex);
    if ($$default !== undefined) {
      return {
              TAG: /* Ok */0,
              _0: Curry._1($$default, undefined)
            };
    }
    var msg = Belt_Option.getWithDefault(Belt_Option.flatMap(Caml_js_exceptions.as_js_exn(ex), (function (prim) {
                return prim.message;
              })), "no message was provided.");
    return {
            TAG: /* Error */1,
            _0: "Parse error: " + msg
          };
  }
}

function parseJson(jsonStr, mapper, validator, $$default, param) {
  try {
    return fromJson(JSON.parse(jsonStr), mapper, validator, $$default, undefined);
  }
  catch (raw_ex){
    var ex = Caml_js_exceptions.internalToOCamlException(raw_ex);
    if ($$default !== undefined) {
      return {
              TAG: /* Ok */0,
              _0: Curry._1($$default, undefined)
            };
    }
    var msg = Belt_Option.getWithDefault(Belt_Option.flatMap(Caml_js_exceptions.as_js_exn(ex), (function (prim) {
                return prim.message;
              })), "no message was provided.");
    return {
            TAG: /* Error */1,
            _0: "Parse error: " + msg
          };
  }
}

var test_pathToStr = pathToStr;

exports.asBoolOpt = asBoolOpt;
exports.asBool = asBool;
exports.boolOpt = boolOpt;
exports.bool = bool;
exports.asNumOpt = asNumOpt;
exports.asNum = asNum;
exports.numOpt = numOpt;
exports.num = num;
exports.asIntOpt = asIntOpt;
exports.asInt = asInt;
exports.intOpt = intOpt;
exports.$$int = $$int;
exports.asStrOpt = asStrOpt;
exports.asStr = asStr;
exports.strOpt = strOpt;
exports.str = str;
exports.asArrOpt = asArrOpt;
exports.asArr = asArr;
exports.arrOpt = arrOpt;
exports.arr = arr;
exports.asObjOpt = asObjOpt;
exports.asObj = asObj;
exports.objOpt = objOpt;
exports.obj = obj;
exports.parseJson = parseJson;
exports.fromJson = fromJson;
exports.test_pathToStr = test_pathToStr;
/* No side effect */
